export default __webpack_public_path__ + "57f8013934b59bfc4507938e74377452.png";